module.exports = __webpack_public_path__ + "static/media/1-5.d432ddb0.png";